import React from 'react';

interface Props {
  className?: string;
  onClick: () => void;
  arialLabel?: string;
  isDiv?: boolean;
  style?: React.CSSProperties;
}

const InteractiveElement: React.FC<Props> = ({ className, onClick, isDiv = true, style, arialLabel = 'input', children }) => {
  const Element = isDiv ? 'div' : 'span';
  return (
    <Element
      className={className}
      onClick={onClick}
      role="button"
      aria-pressed="false"
      aria-label={arialLabel}
      tabIndex={0}
      onKeyDown={() => {}}
      style={style}
    >
      {children}
    </Element>
  );
};

export default InteractiveElement;
